import { render } from "./AllAnnouncementsList.vue?vue&type=template&id=3e477206&scoped=true"
import script from "./AllAnnouncementsList.vue?vue&type=script&lang=js"
export * from "./AllAnnouncementsList.vue?vue&type=script&lang=js"

import "./AllAnnouncementsList.vue?vue&type=style&index=0&id=3e477206&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e477206"]])

export default __exports__